import { createSlice } from "@reduxjs/toolkit"
import { addTestimonial, getActiveTestimonial, getAllTestimonial, getAllTestimonialCount, getInActiveTestimonial, getTestimonial, toggleTestimonialStatus, updateTestimonial } from "../actions/testimonial";

const INITIAL_STATE = {
    isLoading: false,
    isError: false,
    allTestimonialList: [],
    singleTestimonial: null,
    allTestimonialCount: 0,
    inActiveTestimonial: 0,
    activeTestimonial: 0,
    total: 0,
}

export const testimonialSlice = createSlice({
    name: "testimonial",
    initialState: INITIAL_STATE,
    extraReducers: (builder) => {
        //=======================
        // Add testimonial
        //=====================
        builder.addCase(addTestimonial.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(addTestimonial.fulfilled, (state) => {
            state.isLoading = false;
        });
        builder.addCase(addTestimonial.rejected, (state) => {
            state.isError = true;
        });

        //=================================
        // Get all testimonial with pagination
        //=================================
        builder.addCase(getAllTestimonial.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getAllTestimonial.fulfilled, (state, action) => {
            state.isLoading = false;
            state.allTestimonialList = action.payload.data?.data;
            state.total = action.payload.data?.total
        });
        builder.addCase(getAllTestimonial.rejected, (state) => {
            state.isError = true;
        });


        //===========================
        //Get single testimonial
        //===========================
        builder.addCase(getTestimonial.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getTestimonial.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singleTestimonial = action.payload.data?.testimonial;
        });
        builder.addCase(getTestimonial.rejected, (state) => {
            state.isError = true;
        });

        //===========================
        //Get all testimonial count
        //===========================
        builder.addCase(getAllTestimonialCount.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getAllTestimonialCount.fulfilled, (state, action) => {
            state.isLoading = false;
            state.allTestimonialCount = action.payload.data?.testimonial;
        });
        builder.addCase(getAllTestimonialCount.rejected, (state) => {
            state.isError = true;
        });

        //===========================
        //Get inActive testimonial
        //===========================
        builder.addCase(getInActiveTestimonial.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getInActiveTestimonial.fulfilled, (state, action) => {
            state.isLoading = false;
            state.inActiveTestimonial = action.payload.data?.inActiveTestimonial;
        });
        builder.addCase(getInActiveTestimonial.rejected, (state) => {
            state.isError = true;
        });


        //===========================
        //Get active testimonial
        //===========================
        builder.addCase(getActiveTestimonial.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getActiveTestimonial.fulfilled, (state, action) => {
            state.isLoading = false;
            state.activeTestimonial = action.payload.data?.activeTestimonial;
        });
        builder.addCase(getActiveTestimonial.rejected, (state) => {
            state.isError = true;
        });


        //============================
        // toggle testimonial status
        //============================
        builder.addCase(toggleTestimonialStatus.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(toggleTestimonialStatus.fulfilled, (state) => {
            state.isLoading = false;
        });
        builder.addCase(toggleTestimonialStatus.rejected, (state) => {
            state.isError = true;
        });

        //==============================
        //update testimonial
        //=============================
        builder.addCase(updateTestimonial.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(updateTestimonial.fulfilled, (state) => {
            state.isLoading = false;
        });
        builder.addCase(updateTestimonial.rejected, (state) => {
            state.isError = true;
        });
    }
})

export default testimonialSlice.reducer;